import { BrowserRouter, Routes, Route } from 'react-router';
import { AuthProvider } from '@podus/auth';
import { authConfig } from './auth-config';
import { LanguageProvider } from '@/i18n/LanguageContext';
import Home from './pages/Home';

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider config={authConfig}>
                <LanguageProvider>
                    <Routes>
                        <Route index element={<Home />} />
                    </Routes>
                </LanguageProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
